import { render, staticRenderFns } from "./myhealthSL.vue?vue&type=template&id=f9d3a128&scoped=true&"
import script from "./myhealthSL.vue?vue&type=script&lang=js&"
export * from "./myhealthSL.vue?vue&type=script&lang=js&"
import style0 from "./myhealthSL.vue?vue&type=style&index=0&id=f9d3a128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d3a128",
  null
  
)

export default component.exports